module.exports = __webpack_public_path__ + "static/media/TeamAccess.b3cce5e2.svg";